import { render, staticRenderFns } from "./toggle-card.vue?vue&type=template&id=bcf398a4&"
import script from "./toggle-card.vue?vue&type=script&lang=js&"
export * from "./toggle-card.vue?vue&type=script&lang=js&"
import style0 from "./toggle-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports